import React, { useEffect, useContext } from 'react'
import { dataContext, getIrgValue, allAllergens, exportToExcelRep, exportCalculationToExcel } from '../utils.js'
import icon from '../icons.svg'

export default function DocPrint({ data = undefined, actions }) {
  let wndData = ''
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData

  const context = useContext(dataContext)
  const sysConst = context.data['sysConst']
  const catGoods = context.data['catGoods']
  const selUnitType = context.data['selUnitType']
  const getData = context.getData

  let catXXXX = []
  //if (wndData.type==='docCalculation') catXXXX=context.data['catGoods']

  useEffect(() => {
    //console.log('effect1')
    if (typeof getData('sysConst') === 'undefined') getData('sysConst')
    else if (typeof getData('catGoods') === 'undefined') getData('catGoods')
    else if (wndData.type === 'docCalculation' && typeof getData('catGoods') === 'undefined') getData('catGoods')
    // eslint-disable-next-line 
  }, [catGoods, sysConst, catXXXX])

  useEffect(() => {
    if (wndData.printed) return
    const timer = setTimeout(() => {
      window.print()
    }, 1000)
    setWndData({ ...wndData, printed: true })
    return () => clearTimeout(timer)
  }, [])

  const printCalculation = docData => {
    const menu = catGoods.find(el => el.id === docData.good.id)
    let ttl1 = 0
    let ttl2 = 0
    if (wndData.prn_type === 2) {
      return (<>
        <div style={stl0}><div style={{ fontWeight: 'bold', fontSize: 'large', fontStyle: 'italic', flexGrow: '1' }}>{docData.good.name}</div><div style={{ fontWeight: 'bold' }}>Калькуляційна картка № {docData.id}	від {(new Date(docData.date)).toLocaleDateString()}</div></div>
        <div style={stl0}><div style={{ flexGrow: '1' }}>Кількість виробу: <b>{docData.qtt} {(selUnitType.find(x => x.value === docData.good.unit.value) || { name: 'шт' }).name}</b></div><div>вихід нетто: <b>{docData.netto} г</b></div></div>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}><tbody>
          <tr>
            <td style={{ ...stl1, width: '1cm' }}>№ п/п</td><td style={stl2}>Найменування продуктів</td>
            <td style={stl1}>Норма (бруто)</td><td style={stl1}>Нетто (г.)</td>
          </tr>
          {docData.table.map((item, idx) => {
            const good = catGoods.find(el => el.id === item.good_id)
            const unit = selUnitType.find(x => x.value === item.unit) || { name: 'шт' }
            const qtt = parseFloat(item.qtt || 0)
            const prc = parseFloat(item.sum_prc || good.sum_in || 0)
            const sum = prc * qtt
            ttl1 += sum
            return (
              <tr key={idx}>
                <td style={stl1}>{idx + 1}</td><td style={stl2}>{item.good}</td><td style={stl3}>{qtt} {unit.name}</td><td style={stl3}>{item.netto}</td>
              </tr>
            )
          })}
        </tbody></table>
      </>)
    }
    else if (wndData.prn_type) {
      let cooking = null
      const allergens = (menu?.allergens ? menu.allergens.split(',') : []).map(el => ' ' + allAllergens.find(it => it.idx === el).name)
      const allerg = <><div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}>
        <b>Наявність харчових алергенів у страві:</b>{allergens.length ? allergens.toString() : ' алергени відсутні'}.</div><div style={stl0}></div></>
      if (docData.cooking) cooking = <>
        <div style={stl0}><div style={{ width: '100%', fontWeight: 'bold', fontSize: 'large', textAlign: 'center' }}>Технологія приготування страви</div></div>
        <div style={stl0}></div>
        <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}>{docData.cooking}</div>
        <div style={stl0}></div>
      </>
      let conditions = null
      if (docData.conditions) conditions = <>
        <div style={stl0}><div style={{ width: '100%', fontWeight: 'bold', fontSize: 'large', textAlign: 'center' }}>Термін придатності до споживання та умови зберігання</div></div>
        <div style={stl0}></div>
        <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}>{docData.conditions}</div>
        <div style={stl0}></div>
      </>
      let presentation = null
      if (docData.presentation) presentation = <>
        <div style={stl0}><div style={{ width: '100%', fontWeight: 'bold', fontSize: 'large', textAlign: 'center' }}>Спосіб реалізації (подання) споживачу</div></div>
        <div style={stl0}></div>
        <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}>{docData.presentation}</div>
        <div style={stl0}></div>
      </>
      let look = null
      if (docData.look) look = <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}><b>Зовнішній вигляд: </b>{docData.look}</div>
      let colour = null
      if (docData.colour) colour = <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}><b>Колір: </b>{docData.colour}</div>
      let taste = null
      if (docData.taste) taste = <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}><b>Смак і запах: </b>{docData.taste}</div>
      let consistence = null
      if (docData.consistence) consistence = <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}><b>Консистенція: </b>{docData.consistence}</div>
      let characteristics = null
      if (docData.look || docData.colour || docData.taste || docData.consistence) characteristics = <>
        <div style={stl0}><div style={{ width: '100%', fontWeight: 'bold', fontSize: 'large', textAlign: 'center' }}>Характеристика готової страви</div></div>
        <div style={stl0}></div>
        {look}{colour}{taste}{consistence}
        <div style={stl0}></div>
      </>
      let proteins = null
      if (menu?.proteins) proteins = <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}><b>Білки: </b>{menu.proteins} г</div>
      let fat = null
      if (menu?.fat) fat = <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}><b>Жири: </b>{menu.fat} г</div>
      let carbohydrate = null
      if (menu?.carbohydrate) carbohydrate = <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}><b>Вуглеводи: </b>{menu.carbohydrate} г</div>
      let energy = null
      if (menu?.energy) energy = <div style={{ width: '100%', display: 'flex', whiteSpace: 'pre-wrap' }}><b>Білки: </b>{menu.energy} кКал</div>
      let nutritive = null
      if (proteins || fat || carbohydrate || energy) nutritive = <>
        <div style={stl0}><div style={{ width: '100%', fontWeight: 'bold', fontSize: 'large', textAlign: 'center' }}>Харчова та енергетична цінність одної порції</div></div>
        <div style={stl0}></div>
        {proteins}{fat}{carbohydrate}{energy}
        <div style={stl0}></div>
      </>
      let serving = null
      if (parseFloat(docData.qtt) !== 1) serving = <div style={stl0}><div style={{ width: '7cm' }}>Вихід готової страви на {docData.qtt} {(selUnitType.find(x => x.value === docData.good.unit.value) || { name: 'шт' }).name}</div>
        <div style={{ fontWeight: 'bold' }}>{docData.netto} г</div></div>

      return (
        <>
          <div style={stl0}><div style={{ flexGrow: '1' }}>{sysConst.sysFirm}</div><div style={{ fontSize: 'small' }}>"Затверджую"<br />_________________<br />_________________</div></div>
          <div style={stl0}></div>
          <div style={stl0}><div style={{ width: '100%', fontWeight: 'bold', fontSize: 'large', textAlign: 'center' }}>ТЕХНОЛОГІЧНА КАРТА № {docData.id}	від {(new Date(docData.date)).toLocaleDateString()}</div></div>
          <div style={stl0}></div>
          <div style={{ ...stl0, minHeight: 'unset' }}><div style={{ width: '100%', fontWeight: 'bold', fontSize: 'large', textAlign: 'center' }}>{docData.good.name}</div></div>
          <div style={{ width: '70%', borderBottom: 'solid 1px', alignSelf: 'center' }}></div>
          <div style={stl0}><div style={{ width: '100%', fontSize: 'x-small', textAlign: 'center' }}>(найменування блюда)</div></div>
          <div style={stl0}></div>
          <table style={{ borderCollapse: 'collapse', width: '100%' }}><tbody>
            <tr>
              <td rowSpan={2} style={{ ...stl1, width: '1cm' }}>№ п/п</td><td rowSpan={2} style={stl1}>Найменування сировини</td>
              <td colSpan={2} style={stl1}>Норма вмісту сировини у готовій страві</td><td colSpan={2} style={stl1}>Норма вмісту у 1 порції</td>
              <td rowSpan={2} style={{ ...stl1, width: '5cm' }}>Технологічні вимоги до якості сировини</td>
            </tr>
            <tr>
              <td style={{ ...stl1, width: '2cm' }}>Бруто</td>
              <td style={{ ...stl1, width: '2cm' }}>Нетто, у грамах</td>
              <td style={{ ...stl1, width: '2cm' }}>Бруто</td>
              <td style={{ ...stl1, width: '2cm' }}>Нетто, у грамах</td>
            </tr>
            {docData.table.map((item, idx) => {
              const unit = selUnitType.find(x => x.value === item.unit) || { name: 'шт' }
              const qtt = parseFloat(item.qtt || 0)
              const neto = Math.round(parseFloat(item.netto || 0))
              const qtt2 = Math.round(qtt / parseFloat(docData.qtt || 1) * 1000) / 1000
              const neto2 = Math.round(parseFloat(item.netto || 0) / parseFloat(docData.qtt || 1))
              ttl1 += neto
              ttl2 += neto2
              if (idx === 0) return (
                <tr key={idx}>
                  <td style={stl1}>{idx + 1}</td><td style={stl2}>{item.good}</td><td style={stl3}>{qtt} {unit.name}</td><td style={stl3}>{neto}</td>
                  <td style={stl3}>{qtt2} {unit.name}</td><td style={stl3}>{neto2}</td>
                  <td rowSpan={docData.table.length} style={stl1}>Вимоги до якості та безпеки вказані у специфікації сировини</td>
                </tr>
              )
              return (
                <tr key={idx}>
                  <td style={stl1}>{idx + 1}</td><td style={stl2}>{item.good}</td><td style={stl3}>{qtt} {unit.name}</td><td style={stl3}>{neto}</td><td style={stl3}>{qtt2} {unit.name}</td><td style={stl3}>{neto2}</td>
                </tr>
              )
            })}
            <tr>
              <td colSpan={2} style={stl2}>Всього</td><td style={stl3}></td><td style={stl3}>{ttl1}</td>
              <td style={stl3}></td><td style={stl3}>{ttl2}</td><td style={stl1}></td>
            </tr>
          </tbody></table>
          {serving}
          <div style={stl0}><div style={{ width: '7cm' }}>Вихід готової страви на 1 {(selUnitType.find(x => x.value === docData.good.unit.value) || { name: 'шт' }).name}</div>
            <div style={{ fontWeight: 'bold' }}>{menu?.weight || (parseFloat(docData.netto) / (parseFloat(docData.qtt) || 1)).toFixed(0)} г</div></div>
          <div style={stl0}></div>
          <div style={stl0}></div>
          {allerg}{cooking}{conditions}{presentation}{characteristics}{nutritive}
          <div style={stl0}><div style={{ flexGrow: '1' }}>Зав.виробництвом: ________________</div><div style={{ flexGrow: '1' }}>Калькуляцію склав: ________________</div></div>
        </>
      )
    }
    else return (
      <>
        <div style={stl0}><div style={{ flexGrow: '1' }}>{sysConst.sysFirm}</div><div style={{ fontSize: 'x-small' }}>Додаток 2<br />до пункту 1.6 Методичних рекомендацій<br />код за ДКУД 09003102</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ fontWeight: 'bold', fontSize: 'large' }}>КАЛЬКУЛЯЦІЙНА КАРТКА № {docData.id}	від {(new Date(docData.date)).toLocaleDateString()}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ flexGrow: '1' }}>Найменування блюда <i><b>{docData.good.name}</b></i></div><div>Номер рецептури по збірнику  _______________</div></div>
        <div style={stl0}></div>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}><tbody>
          <tr>
            <td style={{ ...stl1, width: '1cm' }}>№ п/п</td><td style={stl2}>Найменування продуктів</td>
            <td style={stl1}>Норма (бруто)</td><td style={stl1}>Нетто (г.)</td><td style={stl1}>Ціна</td><td style={stl1}>Сума</td>
          </tr>
          {docData.table.map((item, idx) => {
            const good = catGoods.find(el => el.id === item.good_id)
            const unit = selUnitType.find(x => x.value === item.unit) || { name: 'шт' }
            const qtt = parseFloat(item.qtt || 0)
            const prc = parseFloat(item.sum_prc || good.sum_in || 0)
            const sum = prc * qtt
            ttl1 += sum
            return (
              <tr key={idx}>
                <td style={stl1}>{idx + 1}</td><td style={stl2}>{item.good}</td><td style={stl3}>{qtt} {unit.name}</td><td style={stl3}>{item.netto}</td><td style={stl3}>{prc.toFixed(2)}</td><td style={stl3}>{sum.toFixed(2)}</td>
              </tr>
            )
          })}
        </tbody></table>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ width: '7cm' }}>Загальна вартість набору на {docData.qtt} {(selUnitType.find(x => x.value === docData.good.unit.value) || { name: 'шт' }).name}</div><div style={{ fontWeight: 'bold' }}>{ttl1.toFixed(2)}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ width: '7cm' }}>Загальна вартість одиниці виробу</div><div style={{ fontWeight: 'bold' }}>{(ttl1 / (parseFloat(docData.qtt) || 1)).toFixed(2)}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ width: '7cm' }}>Продажна ціна блюда</div><div style={{ fontWeight: 'bold' }}>{menu ? menu.sum_out : '_________'}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ width: '7cm' }}>Вихід у готовому виді</div><div style={{ fontWeight: 'bold' }}>{(parseFloat(docData.netto) / (parseFloat(docData.qtt) || 1)).toFixed(2)} г</div></div>
        <div style={stl0}></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ flexGrow: '1' }}>Зав.виробництвом: ________________</div><div style={{ flexGrow: '1' }}>Калькуляцію склав: ________________</div><div style={{ flexGrow: '1' }}>Затверджую: ______________</div></div>
      </>
    )
  }

  //console.log(wndData)
  const stl0 = { width: '100%', display: 'flex', height: 'min-content', minHeight: '5mm' }
  const stl1 = { border: '1px solid', textAlign: 'center' }
  const stl2 = { border: '1px solid' }
  const stl3 = { border: '1px solid', textAlign: 'right' }

  if (!sysConst) return ('')
  if (!catGoods) return ('')

  let ttl1 = 0
  let ttl2 = 0
  let ttl3 = 0
  let ttl1s = 0
  let ttl2s = 0

  //let prn_cont=null

  if (wndData.type === 'docCalculation') {
    if (wndData.arrData && wndData.prn_type !== 2) return (
      <div className='reportContent' style={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 6px)' }}>
        <div className='no-print' style={{ display: 'flex', justifyContent: 'end', paddingTop: '10px', paddingRight: '10px' }} onClick={() => exportCalculationToExcel(wndData, catGoods)}>
          <img style={{ cursor: 'pointer', width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
        </div>
        {wndData.arrData.map((el, idx) => (
          <React.Fragment key={idx}>
            {printCalculation(el)}
            {idx !== wndData.arrData.length - 1 && <div className="page-break"></div>}
          </React.Fragment>
        ))}
      </div>
    )
    if (wndData.arrData) return (
      <div className='reportContent' style={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 6px)' }}>
        <div className='no-print' style={{ display: 'flex', justifyContent: 'end', paddingTop: '10px', paddingRight: '10px' }} onClick={() => exportCalculationToExcel(wndData, catGoods)}>
          <img style={{ cursor: 'pointer', width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
        </div>
        {wndData.arrData.map((el, idx) => (
          <React.Fragment key={idx}>
            {printCalculation(el)}
            {idx !== wndData.arrData.length - 1 && <div style={{ width: '100%', display: 'flex', minHeight: '15mm' }}> </div>}
          </React.Fragment>
        ))}
      </div>
    )
    return (
      <div className='reportContent' style={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 6px)' }}>
        <div className='no-print' style={{ display: 'flex', justifyContent: 'end', paddingTop: '10px', paddingRight: '10px' }} onClick={() => exportCalculationToExcel(wndData, catGoods)}>
          <img style={{ cursor: 'pointer', width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
        </div>
        {printCalculation(wndData)}
      </div>
    )
  }
  else if (wndData.type === 'docExpence') {
    return (
      <div className='reportContent' style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', height: 'calc(100% - 6px)' }}>
        <div className='no-print' style={{ display: 'flex', justifyContent: 'end', paddingTop: '10px', paddingRight: '10px' }} onClick={() => exportToExcelRep(wndData)}>
          <img style={{ cursor: 'pointer', width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
        </div>
        <div style={stl0}><div>{sysConst.sysFirm}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: 'large' }}>АКТ СПИСАННЯ № {wndData.id}	від {(new Date(wndData.date)).toLocaleDateString()}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ width: '4cm' }}>Пірозділ</div><div style={{ fontWeight: 'bold' }}>{wndData.department ? wndData.department.name : '___________'}</div></div>
        <div style={stl0}><div style={{ width: '4cm' }}>Стаття</div><div style={{ fontWeight: 'bold' }}>{wndData.article ? wndData.article.name : '___________'}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><table style={{ borderCollapse: 'collapse', width: '100%' }}><tbody>
          <tr>
            <td style={{ ...stl1, width: '1cm' }}>№ п/п</td>
            <td style={stl1}>Назва</td>
            <td style={stl1}>Кількість</td>
            <td style={stl1}>Од.</td>
            <td style={stl1}>Ціна</td>
            <td style={stl1}>Сума</td>
          </tr>
          {wndData.table.map((item, idx) => {
            const unit = selUnitType.find(x => x.value === item.unit)
            const qtt = parseFloat(item.qtt || 0)
            const sum = parseFloat(item.amount || 0)
            const prc = sum / (qtt || 1)
            ttl1 += sum
            return (
              <tr key={idx}>
                <td style={stl1}>{idx + 1}</td><td style={stl2}>{item.good}</td><td style={stl3}>{qtt}</td><td style={stl1}>{unit.name}</td><td style={stl3}>{prc.toFixed(2)}</td><td style={stl3}>{sum.toFixed(2)}</td>
              </tr>
            )
          })}
          <tr>
            <td colSpan={5} style={{}}><b>Разом</b></td><td style={stl3}><b>{ttl1.toFixed(2)}</b></td>
          </tr>
        </tbody></table></div>
        <div style={stl0}></div>

        <div style={stl0}><div style={{ width: '3.5cm' }}>Голова комісії</div><div style={{ width: '5cm', borderBottom: '1px solid' }}></div><div style={{ width: '.5cm' }}></div><div style={{ width: '2cm', borderBottom: '1px solid' }}></div><div style={{ width: '.5cm' }}></div><div style={{ width: '7cm', borderBottom: '1px solid' }}></div></div>
        <div style={stl0}><div style={{ width: '3.5cm' }}></div><div style={{ width: '5cm', textAlign: 'center', fontSize: 'x-small' }}>(посада)</div><div style={{ width: '.5cm' }}></div><div style={{ width: '2cm', textAlign: 'center', fontSize: 'x-small' }}>(підпис)</div><div style={{ width: '.5cm' }}></div><div style={{ width: '7cm', textAlign: 'center', fontSize: 'x-small' }}>(прізвище, ім'я, по батькові)</div></div>
        <div style={stl0}><div style={{ width: '3.5cm' }}>Члени комісії</div><div style={{ width: '5cm', borderBottom: '1px solid' }}></div><div style={{ width: '.5cm' }}></div><div style={{ width: '2cm', borderBottom: '1px solid' }}></div><div style={{ width: '.5cm' }}></div><div style={{ width: '7cm', borderBottom: '1px solid' }}></div></div>
        <div style={stl0}><div style={{ width: '3.5cm' }}></div><div style={{ width: '5cm', textAlign: 'center', fontSize: 'x-small' }}>(посада)</div><div style={{ width: '.5cm' }}></div><div style={{ width: '2cm', textAlign: 'center', fontSize: 'x-small' }}>(підпис)</div><div style={{ width: '.5cm' }}></div><div style={{ width: '7cm', textAlign: 'center', fontSize: 'x-small' }}>(прізвище, ім'я, по батькові)</div></div>
        <div style={stl0}><div style={{ width: '3.5cm' }}></div><div style={{ width: '5cm', borderBottom: '1px solid' }}></div><div style={{ width: '.5cm' }}></div><div style={{ width: '2cm', borderBottom: '1px solid' }}></div><div style={{ width: '.5cm' }}></div><div style={{ width: '7cm', borderBottom: '1px solid' }}></div></div>
        <div style={stl0}><div style={{ width: '3.5cm' }}></div><div style={{ width: '5cm', textAlign: 'center', fontSize: 'x-small' }}>(посада)</div><div style={{ width: '.5cm' }}></div><div style={{ width: '2cm', textAlign: 'center', fontSize: 'x-small' }}>(підпис)</div><div style={{ width: '.5cm' }}></div><div style={{ width: '7cm', textAlign: 'center', fontSize: 'x-small' }}>(прізвище, ім'я, по батькові)</div></div>
        <div style={stl0}><div style={{ width: '3.5cm' }}></div><div style={{ width: '5cm', borderBottom: '1px solid' }}></div><div style={{ width: '.5cm' }}></div><div style={{ width: '2cm', borderBottom: '1px solid' }}></div><div style={{ width: '.5cm' }}></div><div style={{ width: '7cm', borderBottom: '1px solid' }}></div></div>
        <div style={stl0}><div style={{ width: '3.5cm' }}></div><div style={{ width: '5cm', textAlign: 'center', fontSize: 'x-small' }}>(посада)</div><div style={{ width: '.5cm' }}></div><div style={{ width: '2cm', textAlign: 'center', fontSize: 'x-small' }}>(підпис)</div><div style={{ width: '.5cm' }}></div><div style={{ width: '7cm', textAlign: 'center', fontSize: 'x-small' }}>(прізвище, ім'я, по батькові)</div></div>
      </div>
    )
  }
  else if (wndData.type === 'docSalary') {
    return (
      <div className='reportContent' style={{ /*display: 'flex',*/ flexWrap: 'wrap', flexDirection: 'column', height: 'calc(100% - 6px)' }}>
        <div className='no-print' style={{ display: 'flex', justifyContent: 'end', paddingTop: '10px', paddingRight: '10px' }} onClick={() => exportToExcelRep(wndData)}>
          <img style={{ cursor: 'pointer', width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
        </div>
        <div style={stl0}><div style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: 'large' }}>Розрахунково-платіжна відомість № {wndData.id}	від {(new Date(wndData.date)).toLocaleDateString()}</div></div>
        <div style={stl0}></div>
        <div style={stl0}></div>
        <div style={stl0}><table style={{ borderCollapse: 'collapse', width: '100%' }}><tbody>
          <tr>
            <td style={{ ...stl1, width: '1cm' }} rowSpan="2">№ п/п</td>
            <td style={stl1} rowSpan="2">Працівник</td>
            <td style={stl1} colSpan="2">Відпрацьовано </td>

            {/* Загальний заголовок */}
            <td style={stl1} colSpan="15">Нараховано за видами виплат</td>

            <td style={stl1} colSpan="5">Утримано та враховано</td>
            <td style={stl1} rowSpan="2">До виплати</td>
          </tr>

          <tr>
            <td style={stl1}>Днів</td>
            <td style={stl1}>Годин</td>
            <td style={stl1}>Нараховано оклад</td>
            <td style={stl1}>Поденно</td>
            <td style={stl1}>Погодинно</td>
            <td style={stl1}>Виручка</td>
            <td style={stl1}>Нараховано</td>
            <td style={stl1}>Виручка підрозділа</td>
            <td style={stl1}>Нараховано</td>
            <td style={stl1}>Виручка підрозділа</td>
            <td style={stl1}>Нараховано</td>
            <td style={stl1}>Загальна виручка закладу</td>
            <td style={stl1}>Нараховано</td>
            <td style={stl1}>Премія </td>
            <td style={stl1}>Лікарняні</td>
            <td style={stl1}>Відпускні</td>
            <td style={stl1}>Разом нараховано</td>

            <td style={stl1}>База для податків</td>
            <td style={stl1}>ПДФО</td>
            <td style={stl1}>Військовий збір</td>
            <td style={stl1}>ЄСВ</td>
            <td style={stl1}>Разом податки</td>
          </tr>

          {wndData.table.map((item, idx) => {

            return (
              <tr key={idx}>
                <td style={stl1}>{idx + 1}</td>
                <td style={stl1}>{item.employee}</td>
                <td style={stl1}>{item.days || 0}</td>
                <td style={stl1}>{item.hours || 0}</td>
                <td style={stl1}>{item.sum_m || 0}</td>
                <td style={stl1}>{item.sum_d || 0}</td>
                <td style={stl1}>{item.sum_h || 0}</td>
                <td style={stl1}>{item.amount_a || 0}</td>
                <td style={stl1}>{item.sum_a || 0}</td>
                <td style={stl1}>{item.amount_d1 || 0}</td>
                <td style={stl1}>{item.sum_d1 || 0}</td>
                <td style={stl1}>{item.amount_d2 || 0}</td>
                <td style={stl1}>{item.sum_d2 || 0}</td>
                <td style={stl1}>{item.amount_t || 0}</td>
                <td style={stl1}>{item.sum_t || 0}</td>
                <td style={stl1}>{item.bonus || 0}</td>
                <td style={stl1}>{item.sick || 0}</td>
                <td style={stl1}>{item.vacation || 0}</td>
                <td style={stl1}>{item.totall || 0}</td>

                <td style={stl1}>{item.tax_base || 0}</td>
                <td style={stl1}>{item.inc_tax || 0}</td>
                <td style={stl1}>{item.mil_tax || 0}</td>
                <td style={stl1}>{item.esv || 0}</td>
                <td style={stl1}>{item.taxes || 0}</td>

                <td style={stl1}>{item.amount || 0}</td>
              </tr>
            )
          })}
        </tbody></table></div>
        <div style={stl0}></div>
        <div style={stl0}>
          <div style={{ flexGrow: 1 }}>
            <div>Начальник підрозділу: _______________________</div>
            <div style={{ width: '9cm', textAlign: 'end', fontSize: 'x-small' }}>(прізвище, ім'я, по батькові)</div>
          </div>

          <div style={{ flexGrow: 1 }}>
            <div>Головний бухгалтер: ___________________________</div>
            <div style={{ width: '9cm', textAlign: 'end', fontSize: 'x-small' }}>(прізвище, ім'я, по батькові)</div>
          </div>
        </div>
      </div>
    )
  }
  else if (wndData.type === 'docReject') {
    return (
      <div className='reportContent' style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', height: 'calc(100% - 6px)' }}>
        <div className='no-print' style={{ display: 'flex', justifyContent: 'end', paddingTop: '10px', paddingRight: '10px' }} onClick={() => exportToExcelRep(wndData)}>
          <img style={{ cursor: 'pointer', width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
        </div>
        <div style={stl0}><div style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: 'large' }}>Видаткова накладна (повернення) № {wndData.id}	від {(new Date(wndData.date)).toLocaleDateString()}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ width: '4cm' }}>Відправник</div><div style={{ fontWeight: 'bold' }}>{sysConst.sysFirm}</div></div>
        <div style={stl0}><div style={{ width: '4cm' }}>Отримувач</div><div style={{ fontWeight: 'bold' }}>{wndData.counterpartie ? wndData.counterpartie.name : '___________'}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><table style={{ borderCollapse: 'collapse', width: '100%' }}><tbody>
          <tr>
            <td style={{ ...stl1, width: '1cm' }}>№ п/п</td>
            <td style={stl1}>Назва</td>
            <td style={stl1}>Кількість</td>
            <td style={stl1}>Од.</td>
            <td style={stl1}>Ціна</td>
            <td style={stl1}>Сума</td>
          </tr>
          {wndData.table.map((item, idx) => {
            const unit = selUnitType.find(x => x.value === item.unit)
            const qtt = parseFloat(item.qtt || 0)
            const sum = parseFloat(item.amount || 0)
            const prc = sum / (qtt || 1)
            ttl1 += sum
            return (
              <tr key={idx}>
                <td style={stl1}>{idx + 1}</td><td style={stl2}>{item.good}</td><td style={stl3}>{qtt}</td><td style={stl1}>{unit.name}</td><td style={stl3}>{prc.toFixed(2)}</td><td style={stl3}>{sum.toFixed(2)}</td>
              </tr>
            )
          })}
          <tr>
            <td colSpan={5} style={{}}><b>Разом</b></td><td style={stl3}><b>{ttl1.toFixed(2)}</b></td>
          </tr>
        </tbody></table></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ flexGrow: '1' }}>Відпустив: ________________</div><div style={{ flexGrow: '1' }}>Прийняв: ________________</div></div>
      </div>
    )
  }
  else if (wndData.type === 'docRevision') {
    let table = []
    let table2 = []
    if (wndData.list) {
      table = wndData.list.filter(el => !el.hide).map(el => ({ good_id: el.good.id, good: el.good.name, unit: el.unit.value || el.unit, qtt_a: parseFloat(el.sum_qtt_a || 0) + parseFloat(el.sum_qtt2_a || 0), qtt_f: parseFloat(el.sum_qtt_f || 0) + parseFloat(el.sum_qtt2_f || 0), qtt_p: parseFloat(el.sum_qtt_p || 0) }))
      table2 = (wndData.prod_list || []).filter(el => !el.hide).map(el => ({ good_id: el.good.id, good: el.good.name, unit: el.unit.value || el.unit, qtt_a: parseFloat(el.sum_qtt_a || 0), qtt_f: parseFloat(el.sum_qtt_f || 0), qtt_p: parseFloat(el.sum_qtt_p || 0) }))
    }
    else {
      wndData.table.forEach(el => {
        console.log({ ...el })
        if (parseInt(el.good_type) > 1 && parseFloat(el.qtt_f || 0) + parseFloat(el.qtt_p || 0) === parseFloat(el.qtt_a || 0)) {
          table2.push({ ...el, qtt_a: parseFloat(el.qtt_a || 0), qtt_f: parseFloat(el.qtt_f || 0), qtt_p: parseFloat(el.qtt_p || 0) })
        } else {
          table.push({ ...el, qtt_a: parseFloat(el.qtt_a || 0) + parseFloat(el.qtt2_a || 0), qtt_f: parseFloat(el.qtt_f || 0) + parseFloat(el.qtt2_f || 0), qtt_p: parseFloat(el.qtt_p || 0) })
        }
      })
      //table=wndData.table.map(el=>({...el,qtt_a:parseFloat(el.qtt_a||0)+parseFloat(el.qtt2_a||0),qtt_f:parseFloat(el.qtt_f||0)+parseFloat(el.qtt2_f||0),qtt_p:parseFloat(el.qtt_p||0)}))
    }
    if (wndData.prn_type === 1) table = table.filter(item => parseFloat(item.qtt_a || 0) > parseFloat(item.qtt_f || 0) + parseFloat(item.qtt_p || 0))
    else if (wndData.prn_type === 2) table = table.filter(item => parseFloat(item.qtt_a || 0) < parseFloat(item.qtt_f || 0) + parseFloat(item.qtt_p || 0))
    else if (wndData.prn_type === 3) table = table.map(item => ({ ...item, qtt_a: 0, qtt_f: 0 }))
    let prod_cont = null
    if (table2.length && !wndData.prn_type) {
      prod_cont = <>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ fontWeight: 'bold', fontSize: 'large', width: '100%', textAlign: 'center' }}>Продукція та напівфабрикати перераховані в інгредієнти</div></div>
        <div style={stl0}><table style={{ borderCollapse: 'collapse', width: '100%' }}><tbody>
          <tr>
            <td style={{ ...stl1, width: '1cm' }}>№ п/п</td>
            <td style={stl1}>Назва</td>
            <td style={stl1}>Од.</td>
            <td style={stl1}>Фактично виявлено перевіркою</td>
            {/*<td style={stl1}>Значиться по даних обліку</td>*/}
            <td style={stl1}>В перерахунок</td>
          </tr>
          {table2.map((item, idx) => {
            if (!catGoods) return null
            const unit = selUnitType.find(x => x.value === item.unit) || { name: '' }
            const qtt_a = Math.round(parseFloat(item.qtt_a || 0) * 1000) / 1000
            const qtt_f = Math.round(parseFloat(item.qtt_f || 0) * 1000) / 1000
            const qtt_r = Math.round((qtt_f - qtt_a) * 1000) / 1000
            return (
              <tr key={idx}>
                <td style={stl1}>{idx + 1}</td><td style={stl2}>{item.good}</td><td style={stl1}>{(unit.name)}</td><td style={stl3}>{qtt_f}</td>{/*<td style={stl3}>{qtt_a}</td>*/}<td style={stl3}>{qtt_r}</td>
              </tr>
            )
          })
          }
        </tbody></table></div>
      </>
    }
    return (
      <div className='reportContent' style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', height: 'calc(100% - 6px)' }}>
        <div className='no-print' style={{ display: 'flex', width: '100%', justifyContent: 'end', paddingTop: '10px', paddingRight: '10px' }} onClick={() => exportToExcelRep(wndData, catGoods)}>
          <img style={{ cursor: 'pointer', width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
        </div>
        <div style={stl0}><div>{sysConst.sysFirm}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ fontWeight: 'bold', fontSize: 'large', width: '100%', textAlign: 'center' }}>Акт інвентаризації цінностей станом на {(new Date(wndData.date)).toLocaleDateString()}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ width: '4cm' }}>Пірозділ</div><div style={{ fontWeight: 'bold' }}>{(wndData.department ? wndData.department.name : '___________') + (wndData.department2 && wndData.department2.id ? ', ' + wndData.department2.name : '')}</div></div>
        <div style={stl0}><div style={{ width: '4cm' }}>Стаття</div><div style={{ fontWeight: 'bold' }}>{wndData.article ? wndData.article.name : '___________'}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><table style={{ borderCollapse: 'collapse', width: '100%' }}><tbody>
          <tr>
            <td rowSpan={2} style={{ ...stl1, width: '1cm' }}>№ п/п</td>
            <td rowSpan={2} style={stl1}>Назва</td>
            <td rowSpan={2} style={stl1}>Од.</td>
            <td colSpan={3} style={stl1}>Фактично виявлено перевіркою</td>
            <td colSpan={2} style={stl1}>Значиться по даних обліку</td>
            <td colSpan={2} style={stl1}>Результати перевірки (+ більше, - менше)</td>
          </tr>
          <tr>
            <td style={stl1}>К-сть</td>
            <td style={stl1}>У прод.</td>
            <td style={stl1}>Сума</td>
            <td style={stl1}>К-сть</td>
            <td style={stl1}>Сума</td>
            <td style={stl1}>К-сть</td>
            <td style={stl1}>Сума</td>
          </tr>
          {table.map((item, idx) => {
            if (!catGoods) return null
            const good = catGoods.find(el => el.id === item.good_id)
            let sum_prc = parseFloat(good.sum_in || 0)
            if (good.price_history) sum_prc = parseFloat(getIrgValue(wndData.date, good.price_history) || 0)
            const unit = selUnitType.find(x => x.value === item.unit) || { name: '' }
            const qtt_a = Math.round(parseFloat(item.qtt_a || 0) * 1000) / 1000
            const sum_a = qtt_a * sum_prc
            const qtt_f = Math.round(parseFloat(item.qtt_f || 0) * 1000) / 1000
            const qtt_p = Math.round(parseFloat(item.qtt_p || 0) * 1000) / 1000
            const sum_f = (qtt_f + qtt_p) * sum_prc
            const qtt_r = Math.round((qtt_f + qtt_p - qtt_a) * 1000) / 1000
            ttl1 += qtt_a
            ttl2 += qtt_f
            ttl3 += qtt_p
            ttl1s += sum_a
            ttl2s += sum_f
            if (wndData.prn_type === 3) {
              ttl1 = 0; ttl1s = 0; ttl2 = 0; ttl2s = 0; ttl3 = 0;
              return (
                <tr key={idx}>
                  <td style={stl1}>{idx + 1}</td><td style={stl2}>{item.good}</td><td style={stl1}>{(unit.name)}</td><td style={stl3}></td><td style={stl3}></td><td style={stl3}></td><td style={stl3}></td><td style={stl3}></td><td style={stl3}></td><td style={stl3}></td>
                </tr>
              )
            }
            return (
              <tr key={idx}>
                <td style={stl1}>{idx + 1}</td><td style={stl2}>{item.good}</td><td style={stl1}>{(unit.name)}</td><td style={stl3}>{qtt_f}</td><td style={stl3}>{qtt_p}</td><td style={stl3}>{sum_f.toFixed(2)}</td><td style={stl3}>{qtt_a}</td><td style={stl3}>{sum_a.toFixed(2)}</td><td style={stl3}>{qtt_r > 0 ? '+' + qtt_r : qtt_r}</td><td style={stl3}>{(sum_f - sum_a).toFixed(2)}</td>
              </tr>
            )
          })
          }
          <tr>
            <td colSpan={3} style={{ fontWeight: 'bold' }}>Усього</td>
            <td style={{ fontWeight: 'bold', textAlign: 'right' }}>{ttl2 ? Math.round(ttl2 * 1000) / 1000 : ''}</td><td style={{ fontWeight: 'bold', textAlign: 'right' }}>{ttl3 ? Math.round(ttl3 * 1000) / 1000 : ''}</td><td style={{ fontWeight: 'bold', textAlign: 'right' }}>{ttl2s ? ttl2s.toFixed(2) : ''}</td>
            <td style={{ fontWeight: 'bold', textAlign: 'right' }}>{ttl1 ? Math.round(ttl1 * 1000) / 1000 : ''}</td><td style={{ fontWeight: 'bold', textAlign: 'right' }}>{ttl1s ? ttl1s.toFixed(2) : ''}</td>
            <td style={{ fontWeight: 'bold', textAlign: 'right' }}>{ttl2 - ttl1 > 0 ? '+' + Math.round((ttl2 - ttl1) * 1000) / 1000 : ttl2 - ttl1 < 0 ? Math.round((ttl2 - ttl1) * 1000) / 1000 : ''}</td><td style={{ fontWeight: 'bold', textAlign: 'right' }}>{ttl2s - ttl1s === 0 ? '' : (ttl2s - ttl1s).toFixed(2)}</td>
          </tr>
        </tbody></table></div>
        {prod_cont}
        <div style={stl0}></div>
        <div style={stl0}>Підписи:</div>
        <div style={stl0}><div style={{ width: '10cm' }}>особа, яка проводила контрольну перевірку:</div><div>_____________</div></div>
        <div style={stl0}><div style={{ width: '10cm' }}>голова інвентаризаційної комісії:</div><div>_____________</div></div>
        <div style={stl0}><div style={{ width: '10cm' }}>члени інвентаризаційної комісії:</div><div>_____________</div></div>
        <div style={stl0}><div style={{ width: '10cm' }}></div><div>_____________</div></div>
        <div style={stl0}><div style={{ width: '10cm' }}></div><div>_____________</div></div>
      </div>
    )
  }
  else if (wndData.type === 'docTransfer') {

    return (
      <div className='reportContent' style={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 6px)' }}>
        <div className='no-print' style={{ display: 'flex', justifyContent: 'end', paddingTop: '10px', paddingRight: '10px' }} onClick={() => exportToExcelRep(wndData)}>
          <img style={{ cursor: 'pointer', width: '24px', height: '24px' }} src={icon + '#xlsx'} alt='' />
        </div>
        <div style={stl0}><div>{sysConst.sysFirm}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: 'large' }}>Видаткова накладна (переміщення) № {wndData.id}	від {(new Date(wndData.date)).toLocaleDateString()}</div></div>
        <div style={stl0}></div>
        <div style={stl0}><div style={{ width: '4cm' }}>Відправник</div><div style={{ fontWeight: 'bold' }}>{wndData.dep_from ? wndData.dep_from.name : '___________'}</div></div>
        <div style={stl0}><div style={{ width: '4cm' }}>Отримувач</div><div style={{ fontWeight: 'bold' }}>{wndData.dep_to ? wndData.dep_to.name : '___________'}</div></div>
        <div style={stl0}></div>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}><tbody>
          <tr>
            <td style={{ ...stl1, width: '1cm' }}>№ п/п</td>
            <td style={stl1}>Назва</td>
            <td style={stl1}>Кількість</td>
            <td style={stl1}>Од.</td>
            <td style={stl1}>Ціна</td>
            <td style={stl1}>Сума</td>
          </tr>
          {wndData.table.map((item, idx) => {
            const unit = selUnitType.find(x => x.value === item.unit)
            const qtt = parseFloat(item.qtt || 0)
            const sum = parseFloat(item.amount || 0)
            const prc = sum / (qtt || 1)
            ttl1 += sum
            return (
              <tr key={idx}>
                <td style={stl1}>{idx + 1}</td><td style={stl2}>{item.good}</td><td style={stl3}>{qtt}</td><td style={stl1}>{unit.name}</td><td style={stl3}>{prc.toFixed(2)}</td><td style={stl3}>{sum.toFixed(2)}</td>
              </tr>
            )
          })}
          <tr>
            <td colSpan={5} style={{}}><b>Разом</b></td><td style={stl3}><b>{ttl1.toFixed(2)}</b></td>
          </tr>
        </tbody></table>
        <div style={stl0}></div>
        <div style={{ ...stl0, minHeight: 'unset' }}><div style={{ flexGrow: '1' }}>Відпустив: ________________</div><div style={{ flexGrow: '1' }}>Прийняв: ________________</div></div>
      </div>
    )
  }
  else return (
    <div></div>
  )
}